import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Prismic from 'prismic-javascript'
import { RichText } from 'prismic-reactjs'

import Page from '../../components/Page'

import './style.css'

const apiEndpoint = 'https://buda-vet.cdn.prismic.io/api/v2'
const MAX_PAGE_SIZE = 100

class Cosmetics extends Component {
  state = {
    cosmetics: [],
  }

  async componentDidMount() {
    const api = await Prismic.getApi(apiEndpoint)

    const createQuery = typeName => [
      Prismic.Predicates.at('document.type', typeName),
      { pageSize: MAX_PAGE_SIZE },
    ]
    api
      .query(...createQuery('kutyakozmetika'))
      .then(apiResult =>
        this.setState({ cosmetics: apiResult.results[0].data.text })
      )
  }

  render() {
    return (
      <Page title="Kutyakozmetika" noHero>
        <div className="sectionTitle">Kutyakozmetika</div>
        <Grid className="NewsItem">
          <Row>
            <Col mdOffset={2} md={8}>
              <Col>{RichText.render(this.state.cosmetics)}</Col>
            </Col>
          </Row>
        </Grid>
      </Page>
    )
  }
}

export default Cosmetics



// WEBPACK FOOTER //
// ./src/pages/Cosmetics/index.js